// export const baseUrl = process.env.REACT_APP_LMS_BASE_URL;
export const baseUrl = process.env.REACT_APP_ASSET_BASE_URL;
export const keycloakbaseurl = process.env.REACT_APP_URM_BASE_URL;
export const appserveraddr = process.env.REACT_APP_APP_SERVER_ADDRESS;
export const urmservice = process.env.REACT_APP_URM_SERVICE;
export const serviceBaseURL = process.env.REACT_APP_DATA_SERVICE;
export const dataservice = process.env.REACT_APP_DATA_SERVICE;
export const gisserviceBaseURL = process.env.REACT_APP_GIS_SERVICE;
export const dmscoreservicecontextname =
  process.env.REACT_APP_CORE_CONTEXT_PATH_NAME;
export const userMgmtService = process.env.REACT_APP_DATA_SERVICE;

//user image...
export const getUserImage = "/auth/media/file/";
export const postImage = "/user_profile/change_picture";
export const authUserData = "/user_profile/getUserProfile";
export const changePassword = "/auth/profile/change_password";
export const updateUserData = "/user_profile/update";

//User Management
export const createRole = "/role/create";
export const updateRole = "/role/update";
export const deleteRole = "/role/delete";
export const getAllRole = "/role/getall";
export const getAllActiveRole = "/role/getallActiveRoles";
export const deletePermissionsFromRole = "/role/deletePermissionsFromRole/";
export const findPermissionsByUser = "/role/findPermissionsByUser";
export const findRolesByUser = "/role/findRolesByUser";
export const getAllPermissionsMobile = "/permission/getall/mob"


export const getallUsersByRealm = "/urm/admin/realms/{REALM}/users";
export const getAdminAuthTokenByRealm =
  "/urm/realms/{REALM}/protocol/openid-connect/token";
export const createUserintoRealm = "/urm/admin/realms/{REALM}/users";
export const getallRolesByRealm = "/urm/admin/realms/{REALM}/roles";
export const addPermissionsToRole = "/role/addPermissionsToRole/";
export const createRoleintoRealm = "/urm/admin/realms/{REALM}/roles";

export const getRoleDataByRoleNameURL = "/urm/admin/realms/{REALM}/roles/";
export const getUserDataByEmailAttr =
  "/urm/admin/realms/{REALM}/users?email={EMAIL}&exact=true";
export const assignRolesToUser =
  "/urm/admin/realms/{REALM}/users/{USER_ID}/role-mappings/realm";
export const deleteUserByRealm = "/urm/admin/realms/{REALM}/users/{USER_ID}";
export const userImageUpload = "/user";
export const mediaFileLink = "/media/file";
export const findUsersById = "/user/findUsersById";

// ---------------------------------------------------------------------------------

//User Management
export const updateUserStatusByUserId =
  "/urm/admin/realms/{REALM}/users/{USER_ID}";
export const getUserByUserId = "/urm/admin/realms/{REALM}/users/";
export const getRoleById = "/urm/admin/realms/{REALM}/roles-by-id/";
export const getRolesByUserId =
  "/urm/admin/realms/{REALM}/users/{USER_ID}/role-mappings";
export const updateUserByUserId = "/urm/admin/realms/{REALM}/users/";
export const deletRoleById = "/urm/admin/realms/{REALM}/roles-by-id/";
export const getAllPermissions = "/permission/getall";
export const getUsersFromApp = "/user/getall";

//Resource Management
export const resourceListURL = "/resource/getall";
export const uniqeResourceListURL = "/resource/getUniqueResourceList";
export const createResourceURL = "/resource/create";
export const updateResourceURL = "/resource/update";
export const deleteResourcebyId = "/resource/delete";
export const findResourcesById = "/resource/findResourcesById";

export const regionListURL = "/region/getall";
export const minifiedRegionListURL = "/region/getMinifiedRegionList";
export const getChildRegionsById = "/region/findChildrenRegionsById";
export const findRegionsByUser = "/region/findRegionsByUser";
export const getRestrictedRegionListURL = "/region/getRestrictedRegionList?stateId=STATEID";
export const findRegionsInfoById = "/region/findRegionsInfoById";
export const getBlockAndDistrictBoundaryURL = "/region/getBlockAndDistrictBoundary";

export const resourceTypListURL = "/config/getConfigsByCategoryName/RSRC_KND?stateId=STATEID";
export const agencyListURL = "/agency/getall";
export const createAgencyURL = "/agency/create";
export const agencyTypeListURL = "/config/getConfigsByCategoryName/AGNCY_TYPE?stateId=STATEID";
export const skillListURL = "/config/getConfigsByCategoryName/SKILL?stateId=STATEID";
export const masterDataAttrTypeListURL =
  "/config/getConfigsByCategoryName/MASTER_DATA_TYPE?stateId=STATEID";
export const getConfigsByCategoryName = "/config/getConfigsByCategoryName/";
export const createConfig = "/config/create";
export const updateConfig = "/config/update";
export const deleteConfig = "/config/delete";
export const hierarchylevelListURL = "/region/getall";
export const createResource = "/resource/create";
export const createRegion = "/region/create";
export const assignRoleToUser = "/user/create";
export const updateUserInAppURL = "/user/update";

//Region Management
export const findRegionById = "/region/findRegionsById";
export const updateRegion = "/region/update";
export const deleteRegionURL = "/region/delete";

//AgencyManagement
export const agencyTypeURL = "/config/getConfigsByCategoryName/AGNC_TYP?stateId=STATEID";
export const findAgenciesById = "/agency/findAgenciesById";
export const updateAgencyURL = "/agency/update";
export const deleteAgencyURL = "/agency/delete";

//ContactManagement
export const createContact = "/contact/create";
export const getContacts = "/contact/getallUserAndContacts";
export const getAllContacts = "/contact/getall?stateId=STATEID";
export const updateContact = "/contact/update";
export const deleteContactURL = "/contact/delete";
export const getskillTypesURL = "/config/getConfigsByCategoryName/SKILL?stateId=STATEID";
export const deleteUserById = "/user/delete";
//FacilityManagement
export const createFacility = "/facility/create";
export const getFacilities = "/facility/getall?stateId=STATEID";
export const creategisFacilityEntry = "/create/facility";
export const updateFacility = "/facility/update";
export const updategisFacilityEntry = "/update/facility";
export const findFacilityById = "/facility/findFacilitiesById";
export const getFacilityTypeURL = "/config/getConfigsByCategoryName/FCLTY_TYP?stateId=STATEID";
export const deleteFacilityURL = "/facility/delete";
export const deleteCKById = "/api/upsertAPI?api_key=";

//Master Resource Data Management
export const createMasterResource = "/master_resource/create";
export const getMasterResourceListURL = "/master_resource/getall";
export const resourceActivityListURL = "/master_resource/getResourceActivties";
export const resourceCatListURL = "/master_resource/getResourceCategories/";
export const resourceCatMasterListData = "/config/getResourceCategories";
export const resourceActivityMasterListData = "/config/getResourceActivties";
export const resourceNameListURL = "/master_resource/getResourceNames";
export const getMasterResourceByIdURL =
  "/master_resource/findMasterResourcesById";
export const deleteMasterResourceById = "/master_resource/deleteMasterResource";
export const deleteMasterResourceImageByName = "/master_resource/delete_resource_image";

//Job Title Management
export const createJobTitle = "/job_title/create";
export const getJobTitle = "/config/getConfigsByCategoryName/JOB_TITLE?stateId=STATEID";

//Contact Management
export const findContactsById = "/contact/findContactsById";

//Task Management
export const getTaskConfigsURL = "/config/getConfigsByCategoryNames";
export const createTaskURL = "/task/create";
export const getTaskListURL = "/task/getall?state_id=STATEID";
export const getActiveTasksURL = "/task/getActiveTasks?state_id=STATEID";
export const getDeletedTasksURL = "/task/getDeletedTasks?state_id=STATEID";
export const getTaskListURLById = "/task//getAllByIncident?incident_id=ID&state_id=STATEID";
export const updateTaskURL = "/task/update";
export const deleteTaskURL = "/task/delete";
export const findTaskById = "/task/findTasksById";
export const createTaskandAssign = "/assignTasksToUsers";
export const getMatserUserTaskList = "/task/getmasterusertasks";
export const getIncidentData = "/getData/incident";
export const createNewTask = "/task/assignTasksToUsers"
export const getAllincidents = "/getData/getAllincidents";
export const deleteTaskById = "/task/deleteUserTask"
export const getAllIndlTask = "/task/getuserinditask"

//SOP Management
export const createMasterSOPURL = "/sop_master/create";
export const updateMasterSOPURL = "/sop_master/update";
export const getMasterSOPListURL = "/sop_master/getMasterSOPList";
export const getActiveMasterSOPList = "/sop_master/getActiveMasterSOPList";
export const getActiveMasterSOPDataList = "/sop_master/getActiveMasterSOPDataList";
export const getActiveSOPsList = "/sop_master/getActiveSOPs";
export const getDeletedSOPsList = "/sop_master/getDeletedSOPs";
export const getResourceHistoryBySopMaster = "/sop_master/getResourceHistoryBySopMaster";
export const getResourceHistoryTimeline = "/sop_master/getResourceHistoryTimeline";
export const getActiveMasterSOPById = "/sop_master/getActiveRegionByMasterSOP";
export const getSopInstanceHistory = "/sop/instance/history/";
export const getSOPTasksDtlBySOPId = "/sop_master/getSOPTasksDtlBySOPId/";
export const getSOPRsrcDtlBySOPId = "/sop_master/getSOPRsrcDtlBySOPId/";
export const deleteSopById = "/sop_master/delete";
export const completeNotificationSop = "/task/completeNotificationForSop";
export const sopInstanceList = "/sop/instance/getAllSopInstances"
export const incidentList = "/task/getAllIncidents"
export const sopList = "/sop_master/getAllSOPs"
export const SopTaskTableData = "/sop/instance/getSopTask"
export const sopResourceList = "/sop/instance/getSopResources"
export const facilityListByRegionId = "/facility/getall/"
export const sopGetIncident = "/sop/instance/getIncident"
export const SopUserData = "/sop/instance/getUserByRole"
export const CreateSopInstance = "/sop/instance/createSopInstance"
export const getSopMasterData = "/sop/instance/getSopTaskInstances/"
export const changeSeverityAndUpdateResources = "/sop/instance/changeSeverityAndUpdateResources"
export const CloseSopTask = "/task/closeTask"
export const CancelSopTask = "/task/cancelTask"
export const CancelSopInstance = "/sop/instance/cancel"
export const getAllIncidentsByCtegorySop = "/task/getAllIncidentByCategory/"
export const getAllIncidentsByCtegorySopForLadakh = "/task/getAllIncidentsByCategory/"
export const getAllSopByIncident = "/sop_master/getAllSOPsByIncidentSeverity/"
export const saveCategoryMatrix = "/severity-resource-config/create";
export const getCategoryMatrixList = "/severity-resource-config/getAllData?stateId=STATEID";
export const getActiveCategoryMatrixList = "/severity-resource-config/getActiveData?stateId=STATEID";
export const getDeletedCategoryMatrixList = "/severity-resource-config/getDeletedData?stateId=STATEID";
export const deleteCategoryMatrix = "/severity-resource-config/delete";
export const getMatrixResources = "/severity-resource-config/getByTypeAndSeverity";
export const updateMatrixResource = "/severity-resource-config/update";
export const getMatrixHistory = "/severity-resource-config/history/timeline";
export const getMatrixHistoryByGroup = "/severity-resource-config/history/byGroup";



//My Task Management
export const getMyTaskListURL = "/task/findTasksByUserName";

export const getMyIndividualTaskListURL = "/getData/getuserinditask";
// export const claimMytask = "/task/claimMyTask";
export const claimMytask = "/task/claimMyUploadTask";
// export const completeMytask = "/task/completeTask";
export const completeMytask = "/task/completeUploadTask";
export const completeNotificationtask = "/completeNotification";
export const completeIndiTask = "/completeUserIndiTask";
export const completeIndivTask = "/task/completeUserIndiTask"
export const completeTask = "/task/completeTask";
export const completeNotificationTypeTask = "/task/completeNotification"
export const claimIndTask = "/task/claimMyTaskDailyOperations"

//For Builder
export const createFormStructure = "/formbuilder/create";
export const getFormStructureURL = "/formbuilder/view";
export const gtFormDataByFormNameURL =
  "/formbuilderdata/getFormdataByFormName/";
export const getStoredFormTemplates = "/formbuilder/getStoredFormTemplates";

//For Builder Data
export const createFormDataViaBuilder = "/formbuilderdata/create";

//Dashboard URLS
export const getBlockInfoFloodURL =
  "/dailyfloodreport/getBlockInfoFrFlood?to_date=TODATE&dist_id=DISTID&api_key=APIKEY&from_date=FROMDATE";
export const getAnimalShelterListURL = "/facility_report/getASTabularReport";
export const getCKListURL = "/facility_report/getCKTabularReport";
export const getMealsDetailsURL = "/facility_report/getMealDetailsByMealType";
export const getFloodReliefData = "/facility_report/getFLTabularReport";
export const getFacilityReportAttrByReportIdAndCat =
  "/facility_report/getFacilityReportAttrByReportIdAndCat";
export const getDailyReportListURL = "/dailyreport/getDailyReportTabularView";
export const getDailyReportbyId =
  "/dailyreport/getDailyReportbyId?dailyReportId=";
export const getFacilityOpenReport = "/facility_report/getFacilityOpenReport";
export const getFacilityReport = "/facility_report/getFacilityReport";
export const getFacilitySummaryReport =
  "/facility/getFacilitiesSummaryByFacilityTypeId";
export const getASStats = "/facility_report/getASStats";
export const getFloodEntityStats = "/facility_report/getFloodEntityStats";
export const getDailyReportByDistrict =
  "/dailyfloodreport/getDailyReportbyRegionId";
export const getDailyAffectedReportByDistrict =
  "/dailyfloodreportaffected/getDailyReportAffected";
export const getDailyColdWaveReport =
  "/dailycoldwavereport/getDailyColdWaveReport";
export const getDailyPartiallyAffectedReportByDistrict =
  "/dailyfloodreportpartiallyaffected/getDailyReportPartiallyAffected";
export const getDailyReportByState = "/statefloodreport/getDailyStateReport";
export const getAffectedDailyReportByState =
  "/dailyfloodaffectedreport/getDailyFloodAfected";
export const getPartiallyAffectedDailyReportByState =
  "/dailyfloodpareport/getPADailyReportbyRegionId";
export const getStateFloodCountData =
  "/dailyfloodreport/getDasCountDetails?from_date=FROMDATE&to_date=TODATE";
export const getCurrStateFloodCountData =
  "/api/executeAPI?api_key=get_flood_curr_dashboard";
export const getCurrBarChartData = "/api/executeAPI?api_key=";
export const getForm1StatusData = "/api/executeAPI?api_key=get_form1_status";
export const getBlockWiseReport =
  "/dailyfloodreport/getBlockDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedBlock =
  "/dailyfloodreport/getAffectedBlockDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedDistrict =
  "/dailyfloodreport/getAffectedDistDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedNagarNigam =
  "/dailyfloodreport/getAffectedNagarNigamDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedPanchayat =
  "/dailyfloodreport/getAffectedGramPanchyatsDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedDrilldownView =
  "/dailyfloodreport/API_KEY?from_date=FROMDATE&to_date=TODATE";
export const updateFloodReport = "/dailyfloodreport/update";
export const getDailyFloodReportListURL =
  "/dailyfloodreport/getDailyFloodReport?region_id=ID&reported_on=DATE";
export const cleardailyReportData =
  "/dailyfloodreport/clearFloodReportEntity?report_id=";
//Theme URLS
export const getThemeURL = "/user_profile/getUserProfile";
export const getUserProfileImage = "/user_profile/get_user_image";
export const updateThemeDataURL = "/user_profile/update";
export const updateProfileImage = "/user_profile/updateProfileImage";

export const getRiverListURL = "/config/getConfigsByCategoryName/RVRS?stateId=STATEID";

//Mis report
export const misReportData =
  "/dailyfloodreport/getMISDistrictFloodReport";

export const misReportDataCumm = "/dailyfloodreport/getMISDistrictFloodReportCumulate";


//Facility Dashboard

export const facilityDashboardData = "/dailyfloodreport/getIncidentFacilitiesDetails";

export const getBMSKData = "/dailyfloodreport/getBmskAPIDetails?from_date=FROMDATE"
export const createBmskData = "/dailyfloodreport/createBmsk"


// User Log API's

export const createUserLog = "/user/createUserLog";

export const getUserLog = "/user/getUserLog";

// Human Loss API's

export const getHumanLoss = "/humanLoss/getHumanLossList?reported_on=DATE&distName=DISTNAME&type=VIEW";

export const getPoliceStationDetails = "/policeStationMaster/getPoliceStationMasterDetails";

export const getDisasterList = "/disasterMaster/getDisasterMasterDetails";

export const createHumanLossDetails = "/humanLoss/createDetails?reported_on=DATE";

export const updateHumanLossPrimaryDetails = "/humanLoss/updatePrimary?reported_on=DATE"

export const deleteHumanLossDetailedDetail = "/humanLoss/deleteHumanLossDetail/"

export const deleteHumanLossPrimaryDetails = "/humanLoss/deleteHumanLossPrimaryAndDetail/"

export const humanlossdashboardincidentcarddata = "/humanLoss/getIncidentCount?from_date=FROMDATE&to_date=TODATE"

export const humanlossdashboardincidenttabledata = "/humanLoss/getTabularCount?from_date=FROMDATE&to_date=TODATE&disaster=ID"

export const humanlossdashboardincidenttableblocldata = "/humanLoss/getTabularCountByBlock?from_date=FROMDATE&to_date=TODATE&dist_name=DISTNAME&disaster=ID"

export const humanlosstrendchartdata = "/humanLoss/getTrendChartCount?from_date=FROMDATE&to_date=TODATE&id=ID"

export const humanlossdougnutchartdata = "/humanLoss/getIncidentByIdDonutCount?from_date=FROMDATE&to_date=TODATE&disaster=ID"

export const humanlossbarchartdata = "/humanLoss/getBarChartCount?from_date=FROMDATE&to_date=TODATE&id=ID"


//Cold WAVE

export const updateColdWaveDetails = "/dailycoldwavereport/update?reported_on=DATE"

export const deleteColdWaveDetail = "/dailycoldwavereport/delete"

export const misColdWaveReport = "/dailycoldwavereport/getMISReport"

export const getMISColdWaveCum = "/dailycoldwavereport/getMISCumulate"



//Heat Wave

export const getHeatWaveFormatAReport = "/heatwave/getHeatwaveFormA";

export const getHeatWaveFormatCReport = "/heatwave/getHeatwaveFormC";

export const updateHeatWaveFormAReport = "/heatwave/createPrimary?reported_on=DATE";

export const deleteHeatWaveFormA = "/heatwave/deleteFormA";



export const updateHeatWaveFormCReport = "/heatwave/createHospitalInfo?reported_on=DATE";

export const deleteHeatWaveFormC = "/heatwave/deleteFormC";

export const getHeatWaveFormatBReport = "/heatwave/getHeatwaveFormB";
export const updateHeatWaveFormBReport = "/heatwave/createPrimary?reported_on=DATE";
export const deleteHeatWaveFormB = "/heatwave/deleteFormB";
export const misheatwavereporttoday = "/heatwave/getMISReport"
export const misheatwavereportcumm = "/heatwave/getMISCumulate"
export const miscloudburstreporttoday = "/cloudburst/getMISReport"
export const miscloudburstreportcumm = "/cloudburst/getMISCumulate"
export const misavalanchereporttoday = "/avalanche/getMISReport"
export const misavalanchereportcumm = "/avalanche/getMISCumulate"
export const misglofreporttoday = "/glof/getMISReport"
export const misglofreportcumm = "/glof/getMISCumulate"
export const misearthquakereporttoday = "/earthquake/getMISReport"
export const misearthquakereportcumm = "/earthquake/getMISCumulate"
// export const misheatwavecummulative = "/heatwave/getMISCumulate"


//Fire

export const getFireCommunityKitchenReport = "/fire/getCK/UI";
export const updateFireCommunityKitchenForm = "/fire/createCK?reported_on=DATE";
export const deletFireCommunityKitchenReport = "/fire/delete";
export const firedashboardcardsdata = "/fire/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const firedashboardbarchart = "/fire/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"
export const firedashboardblockdata = "/fire/getBarChartCountByBlock"


export const coldwavecardsdata = "/dailycoldwavereport/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const coldwavechartdata = "/dailycoldwavereport/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"

export const coldwavepopupdata = "/dailycoldwavereport/getBarChartCountByBlock"

//Fire Daily Report

export const getFireReportData = "/fire/getDailyReport"

export const updateFireReportData = "/fire/update"

export const delteFireReportData = "/fire/delete/DR/"

export const deleteAddressFieldData = "/fire/delete/address/"



export const getDailyHeatWaveReport = "/heatwave/getForm/UI";
export const updateHeatWaveDetails = "/heatwave/create?reported_on=DATE";
export const deleteHeatWaveDetail = "/heatwave/deleteForm";
export const getDailyCloudBurstReport = "/cloudburst/getForm/UI";
export const updateCloudBurstDetails = "/cloudburst/create?reported_on=DATE";
export const deleteCloudBurstDetail = "/cloudburst/deleteForm";
export const getDailyAvalancheReport = "/avalanche/getForm/UI";
export const updateAvalancheDetails = "/avalanche/create?reported_on=DATE";
export const deleteAvalancheDetail = "/avalanche/deleteForm";
export const getDailyGlofReport = "/glof/getForm/UI";
export const updateGlofDetails = "/glof/create?reported_on=DATE";
export const deleteGlofDetail = "/glof/deleteForm";
export const getDailyEarthquakeReport = "/earthquake/getForm/UI";
export const updateEarthquakeDetails = "/earthquake/create?reported_on=DATE";
export const deleteEarthquakeDetail = "/earthquake/deleteForm";

export const heatwavecardsdata = "/heatwave/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const heatwavechartdata = "/heatwave/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"
export const heatwavepopupdata = "/heatwave/getBarChartCountByBlock"


export const avalanchecardsdata = "/avalanche/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const avalanchechartdata = "/avalanche/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"
export const avalanchepopupdata = "/avalanche/getBarChartCountByBlock"


export const cloudburstcardsdata = "/cloudburst/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const cloudburstchartdata = "/cloudburst/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"
export const cloudburstpopupdata = "/cloudburst/getBarChartCountByBlock"


export const glofcardsdata = "/glof/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const glofchartdata = "/glof/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"
export const glofpopupdata = "/glof/getBarChartCountByBlock"


export const earthquakecardsdata = "/earthquake/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const earthquakechartdata = "/earthquake/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"
export const earthquakepopupdata = "/earthquake/getBarChartCountByBlock"


//Human Loss MIS

export const getHumanLossMisReport = "/humanLoss/getMISReport";


//Fire incident MIS

export const getFireMisReport = "/fire/getMISReport";

export const getFirMisReportCum = "/fire/getMISCumulate";

export const getColdwaveReportingStatus = "/api/executeAPI?api_key=coldwave_report_status";

export const getHeatWaveReportingStatus = "/api/executeAPI?api_key=heatwave_report_status";
export const getCloudburstReportingStatus = "/api/executeAPI?api_key=cloudburst_report_status";
export const getavalancheReportingStatus = "/api/executeAPI?api_key=avalanche_report_status";
export const getglofReportingStatus = "/api/executeAPI?api_key=glof_report_status";
export const getEarthquakeReportingStatus = "/api/executeAPI?api_key=earthquake_report_status";

export const getFireWaveReportingStatus = "/api/executeAPI?api_key=fire_daily_report_status";

export const executeSopContactList = "/sop/instance/getUserByRole";
export const executeSopContactListByRegion = "/sop/instance/getUserByRoleAndRegion";


export const getServerDateAndTime = "/config/server-time";

export const gisStateCoordinates = "/region/getStateMap/";
export const gisCoordinatesData = "/region/getDistrictMap/";
export const gisBlockCoordinatesData = "/region/getBlockMap/";
export const gisPanchayatCoordinatesData = "/region/getPanchayatMap/";
export const gisVillageCoordinatesData = "/region/getVillageMap/";
export const getGisData = "/branch/incident/getAllBranchesAndATMsAndIncidents";

//newly added
export const getAllDistricts = "/region/getAllDistricts";
export const findAllChildrenRegionsById = "/region/findAllChildrenRegionsById";
export const districtsInGis = "/region/getAllDistricts";
export const ladakhDistrictsInGis = "/region/getAllLadhakDistricts/";
export const getfacilitydatasearch = "/incident/getFacilityData?stateId=STATEID"
export const getfacilitytabledata = "/incident/getFacilityreportData"
export const getresourceData = "/incident/getResourceactivityData?stateId=STATEID"
export const getincidentDatain = "/incident/getIncidentData?stateId=STATEID"
export const getSopInstanceSummaryByState = "/sop/instance/summary?stateId=STATEID"
export const getSopInstanceSummaryByIncident = "/sop/instance/summary?incidentId=INCIDENTID"
export const getSopInstanceSummaryBySopInstance = "/sop/instance/summary/bySopInstance?sopInstanceId=SOPINSTANCEID&incidentId=INCIDENTID"
export const getincidentFilteredDatain = "/incident/getIncidentFilteredData"
export const getshowbasicdet = "/incident/getAllIncidentdtlsData"
export const dashboardSummaryData = "/dashboard/summary/";
export const getcensusdatain = "/incident/getCensusData"
export const getregionincidentdata = "/incident/getAffectedRegionsData"
export const geteventincidentdata = "/incident/getEventReportData"

export const getincidentcatcreate = "/incident/getAllincidents?stateId=STATEID"
export const getconfigdatacate = "/incident/getConfigDataByCode"
export const createincidentsitu = "/incident/createIncident"
export const getgpdetails = "/incident/getPanchayatDataByRegion"
export const getstatusdetails = "/incident/getConfigByName"
export const getpanchaycentersa = "/incident/gePanchayatCenters"

export const removeregiondatavalue = "/incident/getregiongisids"
export const deleteincident = "/incident/closeIncident"

export const updateincident = "/incident/getAllIncidentdetails"
export const updateincidentForLadakh = "/incident/getAllDmsIncidentdetails"
export const geteventdetails = "/incident/getEventWithFilesData"
export const deleteevent = "/incident/deleteEvent"
export const editincident = "/incident/updateIncident"
export const createevent = "/incident/createEvent"
export const saveimageevent = "/incident/saveEventImages"

export const getfacilitydistance = "/incident/getFacilityWithinDistance"
export const resourcedistance = "/incident/getFacilityGisIdsWithinDistanceAndActivity"

export const getfeaturefacility = "/incident/{ID}/getFeatures"

export const getbmskdetails = "/dailyfloodreport/getBmskAPIDetailsByDist"

export const blockuserdetailss = "/incident/usersByBlockId/{ID}"


export const getContactsForAgency = "/contact/getUsersAndContactsByAgencyId?agencyId=ID"

export const getResourcesBasedOnRegion = "/resource/allResourcesByRegion"

export const getSopInstanceResourceById = "/sop/instance/getSopInstanceResourceById/"
export const updateSopInstanceResources = "/sop/instance/updateResources"

export const getResourceDetailsById = "/resource/getResourceDetails"
export const createResourceDeploy = "/resourcedeploy/create"
export const getResourceDeploy = "/resourcedeploy/getAll?stateId=STATEID"
export const getReleaseResourceDeploy = "/resourcedeploy/release"
export const getIncidentRegions = "/incident/getIncidentRegions/"
export const getIncidentSummary = "/incident/getIncidentSummary/"
export const getsearchdetails = '/region/getRegionDataByName'
export const searchshowlatdetails = '/region/searchByName'
export const GrievanceGetAll = '/grievance/getall/268/SA'
export const GrievanceCreate = '/grievance/create'
export const GrievanceStatusChange = '/grievance/inprogress'

//pre disaster alerts

export const alertsgetall = '/disaster-alert-notifications/getall'
export const singlealert = '/disaster-alert-notifications/id/mark-read'
export const markallalert = '/disaster-alert-notifications/mark-all-read'
export const getOpenTicketsCount = "/grievance-notifications/unreadCount"
export const getWebSocketEndpoint = "/ws";
export const acknowledgeupdate ='/disaster-alert-notifications/id/acknowledge'
export const acknowledgeAndAssess = '/disaster-alert-notifications/acknowledge-and-assess'
export const getDisasterAlertsHistory = '/disaster-alert-notifications/getallAlerts'
export const createDisasterAlert = '/disaster-alerts/create-manual'

// Sachet CAP alert feeds (NDMA)
export const sachetLadakhCapAlerts = '/sachet-ladakh/cap-alerts'
export const sachetEarthquakeAlerts = '/sachet-earthquake/alerts'
export const createAlertFromEarthquake = '/sachet-earthquake/alerts/id/create-alert'
export const createAlertFromCapAlert = '/sachet-ladakh/cap-alerts/id/create-alert'
export const capAlertDetail = '/sachet-ladakh/cap-alerts/id/detail'
export const earthquakeAlertDetail = '/sachet-earthquake/alerts/id/detail'


export const deployvehicle = '/vehicledeploy/create'
export const availdeplvehicle ='/vehicledeploy/available'
export const vehiclerelease = '/vehicledeploy/release'
export const getlivedatadeploy ='/vehicledeploy/featch-live-data?vehicleNumbers='
export const liveincident ='/vehicledeploy/live-incidents'

export const filterliveincidents ='/vehicledeploy/getAllLiveIncidents'
export const supportPoints ='/api/support-points?district=name&categoryId=id'
export const getPastDaysWeatherData ='/weather/getByRegionIdAndDate?regionId=REGIONID&date=DATE'
export const getAllStates = '/region/getAllStates'
export const getStateRegions = '/region/state/'
export const updateWeatherDataThresholds = '/weather/update'
export const getWeatherDataThresholds = '/weather/getall/'
//Grievance Module Api's
 
export const getIssueType = "/config/getConfigsByCategoryNames";
export const getIssueTypes = "/config/getConfigsByCategoryNamesAndDepartment";
export const getSubIssueType = "/config/getConfigsBySubCategoryName/GRV_SUB_CAT_TYPE/ID";
export const getSubIssueTypes = "/config/getConfigsBySubCategoryNameAndDepartment/GRV_SUB_CAT_TYPE/ID/StateId";
 
export const getResMethods = "/config/getConfigsByCategoryNames/ID";
export const getCategory = "/config/getConfigsByCategoryNames/ID";
 
export const createGrievance = "/grievance/create";
 
export const fetchGrievanceData = "/grievance/getall";
 
export const grievanceInprogress = "/grievance/inprogress";
export const grievanceResolved = "/grievance/resolved";
export const grievanceClosed = "/grievance/closed";
export const grievanceRejected = "/grievance/reject";
export const grievanceOpen = "/grievance/open";
export const grievanceAccept = "/grievance/accept";
export const commentingForAdmins = "/grievance/commentsMap"
export const acceptAfterEsclation = "/grievance/accept"
export const reopenAfterClosed = "/grievance/reopenTicket"
export const manualEscalateL1 = "/grievance/manualProcessEscalateToL1";
export const manualEscalateL2 = "/grievance/manualProcessEscalateToL2";
export const manualEscalateL3 = "/grievance/manualProcessEscalateToL3";
 
//Manage SLA
export const createSLA = "/SLA/create";
export const updateSLA = "/SLA/update";
export const getAllSLA = "/SLA/getall";
export const deleteSLAById = "/SLA/delete";
 
//Tickets Notification
// export const getOpenTicketsCount ="/grievance-notifications/unreadCount"
export const getNotificationsList ="/grievance-notifications/all"
// export const getWebSocketEndpoint = "/ws";
export const notificationRead = "/grievance-notifications/markRead/ID"
export const notificationMarkAllRead = "/grievance-notifications/markRead/multiple"
export const getGrievanceData = "/grievance/getall/ID"
 
export const getDepartmentsCurrent = "/department/getAllDepartmentsExceptCurrent?departmentId=DEPTID"
export const createCrossDepartment = "/cross-department/transfer"
 
export const getallforuserdet ="/attendance/getAll"
export const getAllPriority = "/SLA/getAllPrioritySLA?priority=PRIORITY";
export const getAllUserNames = "/grievance/getUsersByUserLevel?userLevel=USERLEVEL";
export const getUsersByUserLevelExceptCurrent = "/user/getUsersByUserLevelExceptCurrent?userLevel=L1&userId=USERID&bankCode=BankCode&branchCode=BranchCode";
export const grievanceDepartmentslist = "/department/getallGrievanceDepartments";
export const getBranchUserList = "/grievance/getUsersByUserLevel?userLevel=USERLEVEL&bankCode=BankCode&branchCode=BranchCode";
export const getBankLogoByRole = "/bank/getBankLogoByRole";
 
export const getAvatarDetails = "/user/findUsersById";
export const getL1UserList = "/user/getAllByUserLevel?userLevel=USERLEVEL";
export const getBankandBranchesList = "/bank/getBankAndBranchDetails/BRANCHCODE";
export const getUserLevels = "/config/getUserLevel?categoryName=USER_LEVEL&type=TYPE";
export const assignNewL1User = "/grievance/reassignL1User";
export const getL1UsersForReportedBy = "/user/getL1UsersByBankBranch?bankCode=BANKCODE&branchCode=BRANCHCODE";
export const userListForSupportAdmin = "/user/getSupportTeamAdminUsers";
export const bulkAssign = "/grievance/admin/bulkAssign";
export const assignNewL2User = "/grievance/reassignL2User";
export const grievancePendingUser = "/grievance/pending-user";
export const grievancePendingExternal = "/grievance/pending-external-department";
export const getAuditHistory = "/grievance/audit-history/";
export const getAllAuditHistory = "/grievance/audit-history/0?allGrievances=ALL";
 
 
export const getUsersFromAppByRole = "/user/getAllByRole";
 
 
//Holiday List Apis
 
export const getAllHolidayTypes = "/holiday-types/getall";
export const createHoliday = "/holiday/create";
export const getHolidayList = "/holiday/getall"
export const updateHolidayById = "/holiday/update/Id"
export const deleteHolidayById = '/holiday/delete'
 
 
export const getbarches ='/branch/getAllBranches?bankCode=ID'
export const getallBanks = "/bank/getall";
export const getallBanksByRole = "/bank/getAllByRole";
export const departmentslist = "/department/getall"


//fieldassisment postapi
export const fieldassismentapi ='/field-assessment/create'
export const getUsersGrievance = "/user/getall/STATE_ID";
export const getUsersByLevels = "/user/getUsersByLevels/STATE_ID";
